import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  collapseChevronLabel: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.collapseChevronLabel',
    description: 'Label for the chevron icon that collapses the form card, with the form name as a variable.',
    defaultMessage: 'Collapse form {formName}'
  },
  expandChevronLabel: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.expandChevronLabel',
    description: 'Label for the chevron icon that expands the form card, with the form name as a variable.',
    defaultMessage: 'Expand form {formName}'
  },
  statusOpenForEdits: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.statusOpenForEdits',
    description: 'Text to display in the status lozenge when the form is open for edits.',
    defaultMessage: 'Open for edits'
  },
  statusSubmitted: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.statusSubmitted',
    description: 'Text to display in the status lozenge when the form has been submitted.',
    defaultMessage: 'Submitted'
  },
  statusLockedForEdits: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.statusLockedForEdits',
    description: 'Text to display in the status lozenge when the form is locked.',
    defaultMessage: 'Locked for edits'
  },
  statusLockedTooltip: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.statusLockedTooltip',
    description: 'Tooltip to display in the status lozenge when the form is locked.',
    defaultMessage: 'Only admins are able to update this form.'
  },
  statusInternal: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.statusInternal',
    description: 'Text to display in the status lozenge when the form is internal.',
    defaultMessage: 'Internal'
  }
});